export default __webpack_public_path__ + "static/illustration-content.url-f4e2c063ce98e03b7529c3dcf0c3a481.svg";